import cx from 'classnames';
import React, { useMemo } from 'react';
import FlexView from 'react-flexview';
import styles from './flex-layout.module.scss';
const TypedFlexView = FlexView;
function fixProps(props) {
    const fixedProps = { ...props };
    // https://github.com/buildo/react-flexview/issues/83
    if (fixedProps.basis === 0) {
        fixedProps.basis = '0px';
    }
    return fixedProps;
}
export const View = React.forwardRef((props, ref) => {
    const { spacing, className, ...flexProps } = fixProps(props);
    const spacingClassName = spacing ? `spacing-${spacing}` : '';
    return (React.createElement(TypedFlexView, { ref: ref, className: cx(className, spacingClassName), ...flexProps }));
});
export const Horizontal = (props) => {
    const { vAlignContent, minHeight, ...rest } = fixProps(props);
    const styleObj = useMemo(() => ({
        alignItems: vAlignContent,
        minHeight,
    }), [vAlignContent, minHeight]);
    return (React.createElement(View, { ...rest, className: cx(props.className, styles.horizontal), style: styleObj }));
};
export const Vertical = React.forwardRef((props, ref) => {
    const { hAlignContent, minHeight, ...rest } = fixProps(props);
    const styleObj = useMemo(() => ({
        alignItems: hAlignContent,
        minHeight,
        ...(rest.style || {}),
    }), [hAlignContent, minHeight, rest.style]);
    return (React.createElement(View, { ...rest, className: cx(props.className, styles.vertical), column: true, style: styleObj, ref: ref }));
});
//# sourceMappingURL=flex-layout.js.map